<script lang="ts">
    import { _ } from "svelte-i18n";
    import type { ModelInfoManager } from "../ModelInfoManager";
    import Score from "../../../Score.svelte";

    export let manager: ModelInfoManager;
    let modelTranslationKeyStore = manager.getModelTranslationKeyStore();
</script>

<div class="card-body p-4">
    <h4 class="card-title mb-1">
        {$_(`${$modelTranslationKeyStore}.info.about.title`)}
    </h4>
    <p class="mb-1 small">
        {$_(`${$modelTranslationKeyStore}.info.about.p1.part1`)}
        <a href="https://www.anyways.eu/" target="_blank">
            {$_(`${$modelTranslationKeyStore}.info.about.p1.part2`)}
        </a>.
    </p>
    <p class="mb-1 small">
        {$_(`${$modelTranslationKeyStore}.info.about.p2`)}
    </p>
    <p class="mb-1 small">
        {$_(`${$modelTranslationKeyStore}.info.about.p3.part1`)}
        <a
            href="https://www.anyways.eu/blog/2023-01-05-why-dont-kids-cycle"
            target="_blank">
            {$_(`${$modelTranslationKeyStore}.info.about.p3.part2`)}</a>
        {$_(`${$modelTranslationKeyStore}.info.about.p3.part3`)}
        <a href="https://www.anyways.eu/" target="_blank">
            {$_(`${$modelTranslationKeyStore}.info.about.p3.part4`)}</a>
        {$_(`${$modelTranslationKeyStore}.info.about.p3.part5`)}
    </p>
    <h4 class="mb-1">
        {$_(`${$modelTranslationKeyStore}.info.scoring.title`)}
    </h4>
    <p class="mb-1 small">
        {$_(`${$modelTranslationKeyStore}.info.scoring.p1`)}
    </p>
    <div class="scores">
        <div class="good">
            <Score score={1.4} class="score-main" size={75}>
                {1.4}
            </Score>

            <strong
                >{$_(
                    `${$modelTranslationKeyStore}.info.scoring.scores.very-good`,
                )}</strong>
        </div>
        <div class="bad">
            <Score score={0.7} class="score-main" size={75}>
                {0.7}
            </Score>

            <strong
                >{$_(
                    `${$modelTranslationKeyStore}.info.scoring.scores.could-be-better`,
                )}</strong>
        </div>
        <div class="bad">
            <Score score={0.9} class="score-main" size={75}>
                {0.9}
            </Score>

            <strong
                >{$_(
                    `${$modelTranslationKeyStore}.info.scoring.scores.ok`,
                )}</strong>
        </div>
        <div class="bad">
            <Score score={0.5} class="score-main" size={75}>
                {0.5}
            </Score>

            <strong
                >{$_(
                    `${$modelTranslationKeyStore}.info.scoring.scores.very-bad`,
                )}</strong>
        </div>
    </div>
    <h4 class="mb-1">
        {$_(`${$modelTranslationKeyStore}.info.assumptions.title`)}
    </h4>
    <p class="mb-1 small">
        {$_(`${$modelTranslationKeyStore}.info.assumptions.p1.part1`)}
        <a
            href="https://docs.anyways.eu/vehicle-profiles/bicycle.commute"
            target="_blank"
            >{$_(`${$modelTranslationKeyStore}.info.assumptions.p1.part2`)}</a>
        {$_(`${$modelTranslationKeyStore}.info.assumptions.p1.part3`)}
    </p>
    <p class="mb-1 small">
        {$_(`${$modelTranslationKeyStore}.info.assumptions.p2`)}
    </p>
</div>

<style>
    .scores {
        display: grid;
        grid-auto-flow: column;
        grid-template-rows: 100px 120px;
        grid-template-columns: 50% 50%;
        padding: 10px;
        text-align: center;
    }
</style>
